import Decimal from 'decimal.js'
import isEmpty from 'lodash/isEmpty'
import isNull from 'lodash/isNull'
import isString from 'lodash/isString'
import isUndefined from 'lodash/isUndefined'
import toNumber from 'lodash/toNumber'

// Calculates the difference between visual and calculated vessel draft values
export const calculateVesselDraftDifference = (
  visualValue,
  calculatedValue
) => {
  if (
    isNull(visualValue) ||
    isNull(calculatedValue) ||
    isUndefined(visualValue) ||
    isUndefined(calculatedValue) ||
    !Number.isFinite(toNumber(visualValue)) ||
    !Number.isFinite(toNumber(calculatedValue)) ||
    (isString(visualValue) && isEmpty(visualValue)) ||
    (isString(calculatedValue) && isEmpty(calculatedValue))
  ) {
    return ''
  }
  const difference = new Decimal(visualValue).minus(calculatedValue)
  const val = `${difference.greaterThan(0) ? '+' : ''}${difference.toFixed(2)}`

  return val
}
